import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

export const QRCode: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div className="flex justify-center">
			<div className="size-[140px] rounded-lg border border-solid border-[#e5e5e5] bg-white">
				<picture className="flex h-full items-center justify-center">
					<img
						src="https://static.change.org/images/mobile-app-combined-qr-code-1x.webp"
						srcSet="https://static.change.org/images/mobile-app-combined-qr-code-1x.webp 1x, https://static.change.org/images/mobile-app-combined-qr-code-2x.webp 2x"
						alt={translate('corgi.app_download.bottom_banner_v2.qr_code.image_alt_text')}
						className="w-[130px]"
					/>
				</picture>
			</div>
		</div>
	);
};
